import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';

import ModelRuleAndRuleView from './ModelRuleAndRuleView';
import {ModelRuleView} from "@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View";
import {UnitCaracView} from "@Selectors/builder/myArmyList/make/unit/show/view/UnitCaracView";

interface IUnitDefenseProfilProps {
  armyListUnitId: string
  carac: UnitCaracView
  modelRules: Array<ModelRuleView>
}

const UnitDefenseProfil: React.FC<UnitDefenseProfilProps> = ({armyListUnitId, carac, modelRules}) => {

  return (
    <div className="col-12">
      <table className="content-stats stats-v2 stats-defensive">
        <thead>
        <tr>
          <th scope="col">Defensive</th>
          <th scope="col" className="text-center">Hp</th>
          <th scope="col" className="text-center">Def</th>
          <th scope="col" className="text-center">Res</th>
          <th scope="col" className="text-center">Arm</th>
          <th scope="col" className="text-center">{carac.aeg && 'Aeg'}</th>
          <th scope="col" className="d-none d-md-block"/>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td/>
          <td className="text-center">{carac.hp}</td>
          <td className="text-center">{carac.def}</td>
          <td className="text-center">{carac.res}</td>
          <td className="text-center">{carac.arm}</td>
          <td className="text-center">{carac.aeg != null && carac.aeg}</td>
          <td className="d-none d-md-block">
            <ModelRuleAndRuleView armyListUnitId={armyListUnitId} modelRules={modelRules}/>
          </td>
        </tr>
        </tbody>
      </table>
      <div className="d-block d-md-none content-stats">
        <ModelRuleAndRuleView armyListUnitId={armyListUnitId} modelRules={modelRules}/>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IUnitDefenseProfilProps) => ({
  armyListUnitId: owsProps.armyListUnitId,
  carac: owsProps.carac,
  modelRules: owsProps.modelRules
    .filter(item => item.isDefensive),
});

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UnitDefenseProfil);

type UnitDefenseProfilProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
